import { Env } from "../services/serviceConfig";

export const detectEnvironment = (): Env => {
  const url = window.location.href.toLowerCase().replace(/^https?:\/\//, '');
  if (url.startsWith('alpha')) return Env.ALPHA;
  if (url.startsWith('beta')) return Env.BETA;
  if (url.startsWith('gamma')) return Env.GAMMA;
  if (url.startsWith('localhost')) return Env.LOCAL;
  if (url.startsWith('localhost') || url.startsWith('0.0.0.0')) return Env.LOCAL;
  return Env.PROD;
};
